import { render, staticRenderFns } from "./updateInitialDue.vue?vue&type=template&id=38f1888b&"
import script from "./updateInitialDue.vue?vue&type=script&lang=js&"
export * from "./updateInitialDue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports